import { LoadablePaint } from '@confluence/loadable';

export const ViewPdfMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewPdfMacro" */ '../src/ViewPdfMacroRenderer.tsx'
			)
		).ViewPdfMacroRenderer,
});
